//
// HttpVerb.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var HttpVerb = {
    HTTP_GET:0,
    HTTP_POST:1,
    HTTP_PUT:2,
    HTTP_DELETE:3,
    HTTP_HEAD:4,
    HTTP_OPTIONS:5
};
export default HttpVerb;
